import { useQuery } from '@tanstack/react-query';
import { Typography } from '@volvo/vcdk-react';
import React from 'react';

import { useFleetAccount } from '@/contexts/fleet-account/useFleetAccount';
import { getFleetsUnitsQueryOptions } from '@/service/vpc/queryOptions';
import { fleet } from '@/utils';

type Props = {
  endCustomerUnitId: number;
};

const UnitsFleets: React.FC<Props> = ({ endCustomerUnitId }) => {
  const { fleetAccountId } = useFleetAccount();

  const { data: units } = useQuery(getFleetsUnitsQueryOptions({ fleetAccountId: fleetAccountId! }));
  const unit = units?.find((u) => u.endCustomerUnitId === String(endCustomerUnitId));

  if (!unit) {
    return null;
  }

  const fleets = unit.fleets.map((fl) => fleet.parseFleetName(fl.name).fleetName).join(', ');
  return <Typography variant="caption1">{fleets}</Typography>;
};

export default UnitsFleets;
